import { UserOverview } from './user';
import { WorksheetTypeEnum } from './worksheet';

export enum ClientQueryStatusEnum {
    RESOLVED = 'RESOLVED',
    ACTIVE = 'ACTIVE',
    DRAFT = 'DRAFT',
}

export type ClientQueryReply = {
    id: string;
    rawReply: string;
    structuredReply?: { [key: string]: unknown };
    createdAt: Date;
    updatedAt: Date;
    createdBy: UserOverview;
    clientQueryId: string;
};

export type ClientQuery = {
    id: string;
    workpaperId: string;
    createdAt: Date;
    updatedAt: Date;
    worksheet?: { id: string; name: string; type: WorksheetTypeEnum; hasAccount: boolean };
    otherSchedule?: { id: string; name: string };
    createdBy: UserOverview;
    rawQuery: string;
    structuredQuery?: { [key: string]: unknown } | null;
    body?: string;
    replies: ClientQueryReply[];
    status: ClientQueryStatusEnum;
    resolvedBy?: { id: string; firstName: string; lastName: string; avatarUrl?: string };
};

export type ClientQueryOverview = Omit<ClientQuery, 'body' | 'replies'> & { replies: string[] };

export type ClientQueryStatistics = {
    draft: number;
    active: number;
    resolved: number;
};

export type UpdateClientQueryFields = {
    rawQuery?: string;
    structuredQuery?: { [key: string]: unknown };
    worksheetId?: string | null;

    status?: ClientQueryStatusEnum;
};
